import { render, staticRenderFns } from "./thinking.vue?vue&type=template&id=3ba11994&scoped=true&"
import script from "./thinking.vue?vue&type=script&lang=js&"
export * from "./thinking.vue?vue&type=script&lang=js&"
import style0 from "./thinking.vue?vue&type=style&index=0&id=3ba11994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba11994",
  null
  
)

export default component.exports